import React, { useMemo } from 'react';
import { Box } from '@mui/material';
import OdpovediHasicu from './OdpovediHasicu';
import { Odpoved, DisplejStylOdpovedi } from '../api/JsdhNotifikaceService/generated';

interface OdpovediStylePreviewProps {
    displejStyl: DisplejStylOdpovedi;
    showSpecializace?: boolean;
    adaptivniLayout?: boolean;
}

// V preview záměrně NEPLNÍME cas — formatTime na prázdno vrátí prázdno → time se nerenderuje
// a jméno hasiče má celý slot karty. Použité kratší jména pro preview (delší by se v úzkém
// preview boxu i tak ořezala ellipsis).
const buildSampleData = (): Odpoved[] => [
    {
        id: 1, poplachId: 0, uzivatelId: 1,
        jmeno: 'Petr Novák',
        odpoved: 'JEDU', cas: '',
        funkce: [{ id: 1, kod: 'VD', nazev: 'Velitel družstva' }],
        funkceAsString: 'Velitel družstva',
        specializace: [{ id: 1, kod: 'NDT', nazev: 'Nositel DT' }],
    },
    {
        id: 2, poplachId: 0, uzivatelId: 2,
        jmeno: 'Tomáš Brada',
        odpoved: 'JEDU', cas: '',
        funkce: [{ id: 2, kod: 'S', nazev: 'Strojník' }],
        funkceAsString: 'Strojník',
        specializace: [{ id: 2, kod: 'PILAR', nazev: 'Pilař' }],
    },
    {
        id: 3, poplachId: 0, uzivatelId: 3,
        jmeno: 'Lukáš Bureš',
        odpoved: 'JEDU', cas: '',
        funkce: [],
        funkceAsString: '',
        specializace: [{ id: 1, kod: 'NDT', nazev: 'Nositel DT' }],
    },
    {
        id: 4, poplachId: 0, uzivatelId: 4,
        jmeno: 'Jan Hájek',
        odpoved: 'NEJEDU', cas: '',
        funkce: [],
        funkceAsString: '',
        specializace: [{ id: 2, kod: 'PILAR', nazev: 'Pilař' }],
    },
    {
        id: 5, poplachId: 0, uzivatelId: 5,
        jmeno: 'Petr Vlček',
        odpoved: 'NEJEDU', cas: '',
        funkce: [],
        funkceAsString: '',
        specializace: [{ id: 1, kod: 'NDT', nazev: 'Nositel DT' }],
    },
];

const OdpovediStylePreview: React.FC<OdpovediStylePreviewProps> = ({
    displejStyl,
    showSpecializace = true,
    adaptivniLayout = false,
}) => {
    const data = useMemo(() => buildSampleData(), []);

    return (
        <Box
            sx={{
                px: 1,
                py: 0.5,
                border: 1,
                borderColor: 'divider',
                borderRadius: 1,
                backgroundColor: 'background.default',
                // Bez maxWidth — preview vyplní dostupný prostor (1fr v gridu admin formu).
                // STRIPE preview variables (kompaktní karty)
                '--dashboard-card-jmeno': '0.7rem',
                '--dashboard-card-jmeno-medium': '0.8rem',
                '--dashboard-card-jmeno-large': '0.95rem',
                '--dashboard-card-meta': '0.6rem',
                '--dashboard-card-meta-large': '0.7rem',
                '--dashboard-card-row-height': '28px',
                '--dashboard-card-row-height-large': '36px',
                // BACKGROUND_TINTED preview variables — proporcionálně menší pro preview;
                // defaultní 1.6rem/2rem se v úzkém boxu nevejdou.
                '--dashboard-tinted-card-jmeno': '0.75rem',
                '--dashboard-tinted-card-jmeno-no-chips': '0.85rem',
                '--dashboard-tinted-card-meta': '0.65rem',
                '--dashboard-tinted-card-row-height': '36px',
                '--dashboard-tinted-chip-fontsize': '0.55rem',
                '& > .MuiBox-root': { pt: 0 },
            }}
        >
            <OdpovediHasicu
                odpovedi={data}
                showSpecializace={showSpecializace}
                displejStyl={displejStyl}
                adaptivniLayout={adaptivniLayout}
            />
        </Box>
    );
};

export default OdpovediStylePreview;
